import React from "react";
import { CalendarPlus, Download } from "lucide-react";
import { googleCalendarUrl, downloadICS } from "@/lib/calendarLinks";

export const AddToCalendar = ({ booking, withName = "", className = "" }) => {
  if (!booking?.scheduled_at) return null;
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <a
        href={googleCalendarUrl(booking, withName)}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs font-semibold text-[#0F172A] border border-[#E4E4E1] px-2.5 py-1.5 rounded-sm hover:border-[#0F172A] transition-colors bg-white"
        data-testid={`gcal-link-${booking.booking_id}`}
      >
        <CalendarPlus size={12} /> Google Calendar
      </a>
      <button
        onClick={() => downloadICS(booking, withName)}
        className="inline-flex items-center gap-1 text-xs font-semibold text-[#52525B] border border-[#E4E4E1] px-2.5 py-1.5 rounded-sm hover:border-[#0F172A] hover:text-[#0F172A] transition-colors bg-white"
        data-testid={`ics-download-${booking.booking_id}`}
      >
        <Download size={12} /> .ics invite
      </button>
    </div>
  );
};
